/* tslint:disable:max-line-length */
import React from 'react';
import { IconTypeProps } from '../types';
import classNames from 'classnames';

export const MailIcon = ({
  className,
  color = '#595959',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8996 11.5333C13.1758 11.5333 13.3996 11.3095 13.3996 11.0333V5.41755C13.3996 4.7324 13.0552 4.10281 12.4781 3.73328L11.2746 2.96267V1.09998C11.2746 0.823804 11.0508 0.599976 10.7746 0.599976H3.22461C2.94844 0.599976 2.72461 0.823804 2.72461 1.09998V2.96052L1.52187 3.72986C0.944336 4.09929 0.599609 4.72917 0.599609 5.41472V11.4C0.599609 12.5028 1.49678 13.4 2.59961 13.4H11.3996C12.5024 13.4 13.3996 12.5028 13.3996 11.4C13.3996 11.1238 13.1758 10.9 12.8996 10.9C12.6234 10.9 12.3996 11.1238 12.3996 11.4C12.3996 11.9513 11.951 12.4 11.3996 12.4H2.59961C2.04824 12.4 1.59961 11.9513 1.59961 11.4V6.06589L5.94346 8.76697C6.26924 8.96951 6.63437 9.07078 6.99961 9.07078C7.36475 9.07078 7.73008 8.96951 8.05576 8.76697L12.3996 6.06589V11.0333C12.3996 11.3095 12.6234 11.5333 12.8996 11.5333ZM11.9389 4.57546C12.0898 4.67214 12.2085 4.80456 12.2878 4.95779L11.2746 5.58787V4.15007L11.9389 4.57546ZM2.06074 4.57234L2.72461 4.14763V5.58787L1.71025 4.9571C1.78965 4.80281 1.90889 4.66941 2.06074 4.57234ZM7.52764 7.91775C7.20195 8.12029 6.79727 8.12029 6.47158 7.91775L3.72461 6.20964V1.59998H10.2746V6.20964L7.52764 7.91775Z"
        fill={color}
      />
    </svg>
  );
};
